<template>
	<div>
		<div id="operationRightChart" style="width: 100%; height: 5.2rem;"></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				chart: null,
			};
		},
		props: ["chartData"],
		watch: {
			'chartData': {
				handler() {
					this.draw();
				},
				deep: true
			}
		},
		mounted() {
			this.draw();
		},
		methods: {
			draw() {
				// 基于准备好的dom，初始化echarts实例
				this.chart = this.$echarts.init(
					document.getElementById("operationRightChart")
				);

				let option = {
					title: {
						text: '温湿度数据曲线',
						left: 'left',
						textStyle: {
							color: '#fff'
						}
					},
					tooltip: {
						trigger: 'axis'
					},
					legend: {
						show: true,
						orient: 'horizontal',
						right: 10,
						top: 0,
						textStyle: {
							fontSize: 12,
							fontWeight: 'bold',
							color: '#fff'
						},
					},
					xAxis: {
						type: "category",
						data: this.chartData[2],
						axisLabel: {
							show: true,
							textStyle: {
								color: '#fff',
								padding: [0, 0, 0, 30]
							}
						},
						axisTick: {
							show: true
						},
						axisLine: {
							show: true
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: '#323232',
								type: "dashed"
							}
						}
					},
					yAxis: [{
							type: "value",
							name: '温度（℃）/湿度（%）',
							nameTextStyle: {
								color: '#fff'
							},
							min: 0,
							max: 100,
							axisLabel: {
								formatter: function(value) {
									return value;
								},
								textStyle: {
									color: '#fff'
								}
							},
							splitLine: {
								show: true,
								lineStyle: {
									color: '#323232',
									type: "dashed"
								}
							}
						},
						// {
						// 	type: "value",
						// 	name: '湿度（%）',
						// 	nameTextStyle: {
						// 		color: '#fff'
						// 	},
						// 	min: 0,
						// 	max: 100,
						// 	axisLabel: {
						// 		formatter: function(value) {
						// 			return value;
						// 		},
						// 		textStyle: {
						// 			color: '#fff'
						// 		}
						// 	},
						// 	splitLine: {
						// 		show: true,
						// 		lineStyle: {
						// 			color: '#323232',
						// 			type: "dashed"
						// 		}
						// 	}
						// }
					],
					series: [{
						type: "line",
						name: "温度",
						smooth: true,
						data: this.chartData[0],
						itemStyle: {
							normal: {
								color: '#41E4BB',
								borderWidth: 3,
								borderColor: '#41E4BB'
							}
						},
						lineStyle: {
							color: '#41E4BB'
						}
					}, {
						type: "line",
						name: "湿度",
						smooth: true,
						data: this.chartData[1],
						itemStyle: {
							normal: {
								color: '#2A9DFF',
								borderWidth: 3,
								borderColor: '#2A9DFF'
							}
						},
						lineStyle: {
							color: '#2A9DFF'
						}
					}, ],
				};
				this.chart.setOption(option);
			},
			// refresh(data) {
			// 	let option = this.chart.getOption();
			// 	var showList = new Array();
			// 	var hiddenList = new Array();
			// 	var wordList = new Array();
			// 	// let coutSum = data[0];
			// 	let temp = 0;
			// 	for (let index = 0; index < data.length; index++) {
			// 		const element = data[index];
			// 		wordList.push(element.X0);
			// 		showList.push(element.COUNT);
			// 		if (index > 1) {
			// 			temp += data[index - 1].COUNT;
			// 		}
			// 		hiddenList.push(temp);
			// 	}

			// 	option.xAxis[0].data = wordList;
			// 	option.series[0].data = hiddenList;
			// 	option.series[1].data = showList;

			// 	// console.log(wordLisst)
			// 	// console.log(hiddenList)
			// 	// console.log(showList)
			// 	this.chart.setOption(option);

			// },
		},

		destroyed() {
			window.onresize = null;
		},
	};
</script>

<style lang="scss" scoped>
</style>
